import { Session } from "next-auth";
import { useSession } from "next-auth/react";

export const getSessionToken = (
    session: Session | undefined | null,
): string | undefined => {
    if (session === null || session === undefined) return undefined;

    if ("token" in session && typeof session.token === "string")
        return session.token;

    return undefined;
};

export const useToken = (): string => {
    const session = useSession();

    const token = getSessionToken(session.data);
    if (token === undefined) throw new Error("Session token not exists.");

    return token;
};
